import { createSelector } from 'reselect';

import type { RootState } from 'typesafe-actions';
import type { BannerState } from './reducer';

export const getBanner = (state: RootState) => state.banner;

export const getIsFetching = createSelector(getBanner, (state: BannerState) => state.isFetching);
export const getItem = createSelector(getBanner, (state: BannerState) => state.item);
export const getIsError = createSelector(getBanner, (state: BannerState) => state.isError);
